/*
https://splidejs.com/guides/getting-started/
*/
import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelector('.video-carousel .splide');

    if( slider ) {
        var splide = new Splide( '.video-carousel .splide' , {
            type: 'loop',
            rewind: true,
            speed: 1000,
            arrows: true,
            pagination: false,
            perPage: 3,
            perMove: 1,
            gap: '20px',
            arrowPath: 'M13.92 10.66C14.16 10.42 14.26 10.08 14.26 9.74C14.26 9.42 14.16 9.08 13.92 8.92L7.99999 2.92C7.75999 2.66 7.49999 2.5 7.07999 2.5C6.75999 2.5 6.49999 2.58 6.25999 2.84C5.99999 3.08 5.83999 3.42 5.83999 3.74C5.83999 4.08 5.91999 4.42 6.15999 4.66L11.26 9.84L6.07999 15.42C5.83999 15.66 5.75999 16 5.75999 16.34C5.75999 16.66 5.91999 17 6.15999 17.26C6.41999 17.42 6.75999 17.5 7.07999 17.5C7.41999 17.5 7.75999 17.34 7.99999 17.08L13.92 10.66Z',
            breakpoints: {
                768: {
                    perPage: 1
                },
            }
        });
        splide.mount();
    }
})